export const visit = (vm, at) => {
vm(require("foundations-components/lang/pt-br.lyaml"));
at({ "pt-br": { "placeholder": "texto tempor\xE1rio" } });
};